import { getUniversityGroupId } from './Helpers';

import { ACCOUNT, startRegistration } from '../redux/actions/accountActions';
import { SINGLE_UNIVERSITY_WIDGET_INFO } from '../redux/actions/widgetActions';

import store from '../redux/store';

export const groupTapFeedExperienceBasedQuestions = ({ university, id, userId, name, account, type }) => {
    const onSuccess = (data) => {
        if (data?.institution?.isEnabledExperienceBasedQuestions) {
            store.dispatch({
                type: ACCOUNT.OPEN_EXPERIENCE_BASED_QUESTIONS_POPUP,
                payload: { university, id: userId || id, name, universitySettings: data?.institution },
            });
        } else if (!account) {
            store.dispatch(startRegistration({ university, id, userId, name, type }));
        }
    };
    store.dispatch({
        type: SINGLE_UNIVERSITY_WIDGET_INFO,
        payload: {
            university_id: university?.id,
        },
        onSuccess: onSuccess,
    });
};

export const showExperienceBasedQuestions = () => {
    const universityGroupId = getUniversityGroupId();
    const environment = process.env.APP_ENV;

    const GROUP_IDS_DEV = new Set([
        '2', // Group for test
    ]);

    const GROUP_IDS_STAGING = new Set([
        '2', // Group for test
    ]);
    const GROUP_IDS_PROD = new Set([
        '1', // Group for test
        '27', // Group for test
    ]);

    switch (environment) {
        case 'development':
            return GROUP_IDS_DEV.has(universityGroupId);
        case 'staging':
            return GROUP_IDS_STAGING.has(universityGroupId);
        case 'production':
            return GROUP_IDS_PROD.has(universityGroupId);
        default:
            return false;
    }
};
